/////////////////////////////////////
//////////// GLOBAL TEXT ////////////
/////////////////////////////////////

/////////////////////////////////////
//////////// SPANISH ////////////
/////////////////////////////////////
export const welcomeEs = {
  titleIntro:
    'Investigando sobre la relación a la marca y la percepción de los chatbots de marca',
  title: 'Hola y bienvenido(a)',
  subTitleInf: 'INFORMACION ACERCA DEL ESTUDIO',
  inf1Par:
    'Bienvenido a mi encuesta sobre Chatbots, Soy Camilo ROJAS-CONTRERAS, estudiante de doctorado en Ciencias de Gestión en la Universidad Grenoble Alpes, Francia, bajo la supervision de Pierre VALETTE-FLORENCE.',
  inf2Par:
    'Usted ha sido invitado para hacer parte de un estudio que busca explorar los posibles efectos de la relación con la marca sobre la percepción de los chatbots de marca. Antes de que usted decida participar, es importante que usted entienda porqué se realiza esta investigación y cuáles son sus posibles implicaciones. Por favor tome el tiempo de leer la siguiente información. En caso que usted requiera información adicional, tiene la libertad de contactar el investigador principal del proyecto, Camilo Rojas. Usted encontrará los datos de contacto al final de esta página de presentación.',
  goalTitle: '¿CUÁL ES EL OBJETIVO DE ESTA INVESTIGACIÓN?',
  goalPar:
    'Con el fin de proponer mejoras en el despliegue de asistentes virtuales, este estudio busca comprender la manera en que la relación con la marca impacta en la percepción y experiencia de los chatbots.',
  botDefTitle: '¿QUÉ SON LOS CHATBOTS?',
  botDefPar:
    'Los asistentes virtuales conversacionales o chatbots, son programas que buscan simular una conversación (o chat) mediante el uso de lenguaje natural en la interacción con el usuario mediante aplicaciones, sitios web o dispositivos móviles. Estos son utilizados con el fin de mejorar la experiencia del cliente en procesos de compra, atención al cliente, gestión de pagos, entre otros.',
  criterTitle: '¿CUMPLO CON LOS CRITERIOS DE PARTICIPACIÓN?',
  criterPar:
    'Para participar en este estudio, usted debe ser mayor de 18 años. Esta investigación está abierta tanto para estudiantes como no estudiantes. De igual forma, no hay restricciones de género en este estudio.',
  questAboutTitle:
    '¿SOBRE QUÉ ASPECTOS ME PREGUNTARÁN Y QUÉ OCURRIRÁ CON MIS DATOS?',
  questAbout1Par:
    'Durante el diligenciamiento de este cuestionario usted permanecerá anónimo, se preguntarán aspectos demográficos como edad, género y categoría socio-profesional. La encuesta se compone de 5 cuestionarios relacionados con relación a la marca, antropomorfismo, distancia social y aceptación de chatbots. Esta encuesta toma entre 7 y 9 minutos para ser completada.',
  questAbout2Par:
    'Sus datos son guardados electrónicamente y protegidos bajo contraseña. Usted no recibirá copia de los datos acá recopilados. El investigador principal, supervisor, al igual que integrantes relevantes de la Universidad Grenoble Alpes tendrán acceso solamente con fines académicos.',
  questAbout3Par:
    'Tras completar este estudio, sus respuestas se mantendrán anónimas incluso para publicaciones y presentaciones que se deriven. Esto incluye la posibilidad de compartir información con otros investigadores, siempre que la información permanezca anónima y bajo nuestra autorización, sin la posibilidad de ser compartida por terceros.',
  contactTitle: 'Contacto del investigador principal:',
  contactPar:
    "Camilo ROJAS-CONTRERAS, Estudiante de Doctorado en Ciencias de Gestión, Universidad Grenoble Alpes. Oficina Sala mainguy CETA C.E.R.A.G. 150 Rue de la Chimie 38040 Saint-Martin-d'Hères, France.",
  // Correo: camilo.rojas@univ-grenoble-alpes.fr",
  ///////////////////////////////////////////////
  default1NotUser:
    'Bienvenido a mi encuesta sobre Chatbots, Soy Camilo ROJAS-CONTRERAS, estudiante de doctorado en Ciencias de Gestión en la Universidad Grenoble Alpes, Francia, bajo la supervision de Pierre VALETTE-FLORENCE.',
  default2NotUser:
    'Esta encuesta busca comprender la forma en que los consumidores perciben las marcas al igual que los Asistentes Virtuales Inteligentes. El cuestionario abarca sus intereses en las marcas, su percepción de los chatbots, así como sus expectativas y opiniones.',
  defaultUserExist:
    'Tu participación será de gran utilidad para esta investigación. Pronto serás redirigido para obtener tus puntos.',
  default3NotUser:
    'Para participar o volver a participar, por favor contacte la plataforma de encuestas que le ha brindado este vínvulo web',

  endThanks: '¡Gracias de nuevo!',
  selBrand:
    'Para continuar por favor selecciones una marca e indique si la ha usado',
  mandFIelds: 'Todos los campos son obligatorios',
  alertRgpd:
    'Para continuar, por favor acepte el tratamiento de los datos personales',
  lang:
    'Para realizar esta encuesta, por favor diligencie su idioma de predilección, luego presione continuar',
  firstP:
    'Soy Camilo ROJAS-CONTRERAS, estudiante de doctorado en Ciencias de Gestión en la Universidad Grenoble Alpes, Francia, bajo la supervision de Pierre VALETTE-FLORENCE. Esta encuesta busca comprender la forma en que los consumidores perciben las marcas al igual que los Asistentes Virtuales Inteligentes. El cuestionario abarca sus intereses en las marcas, su percepción de los chatbots, así como sus expectativas y opiniones.',
  secondP:
    'Los datos personales recabados a través de esta encuesta son tratados bajo su consentimiento.',
  thirdP:
    'Sus respuestas son opcionales y la falta de respuesta no tiene consecuencias. Sus datos se transmitirán únicamente a las personas autorizadas, que están obligadas a guardar confidencialidad, y se mantendrán durante 24 meses tras la finalización del estudio. Sus datos no se utilizarán en ningún caso con fines comerciales.',
  // "Si desea obtener mayor información, no dude en contactarme al correo: camilo.rojas@univ-grenoble-alpes.fr',
  question:
    'Al hacer clic en "Si" a continuación, está indicando que tiene al menos 18 años, que ha leído este formulario de consentimiento y que acepta participar en este estudio de investigación y el tratamiento de sus datos.',
  yes: 'Si',
  no: 'No',
  cont: 'Continuar',
  brandSel: 'A continuación, selecciona tu marca preferida.',
  brandDistant:
    'Para esta encuesta te pediré que elijas la marca que es MENOS conocida para tí, si es posible, que no la hayas usado',
  usedBrand: '¿Usas o has usado alguna vez esta marca?',
  vidTxt1: 'Con el fin de que te familiarices con el chatbot de ',
  vidTxt2: ', mira el siguiente vídeo antes de completar el cuestionario.',
  levelUp:
    'Perfecto!!, hemos superado la primera etapa ¿te parece si continuamos?',
  title1End: 'Gracias por tu aporte  ',
  title2End:
    '! para terminar la encuesta por favor diligencia los datos a continuación, luego presiona en "finalizar"',
  ageUser: '¿Cuál es tu edad?',
  ageLabel: 'Edad',
  cspUser: '¿Cuál es tu ocupación?',
  agric: 'Agricultor',
  comerce: 'Comerciante, Artesano o independiente',
  chef: 'Ejecutivo o profesión intelectuales superiores',
  employ: 'Asalariado',
  ouvrier: 'Obrero',
  retaite: 'Pensionado',
  student: 'Estudiante',
  inactif: 'Sin ocupación',
  genderUser: 'y ¿Tu género?',
  genA: ' 🧑 Hombre',
  genAa: 'masculino',
  genB: '👧 Mujer',
  genBb: 'femenino',
  genC: '🧑‍🦱 No-binario',
  genCc: ' de género no-binario',
  finish: 'Finalizar',
  noFolSurvey1:
    'Lo sentimos, en este momento la encuesta no se encuentra disponible',
  noFolSurvey2:
    'Por favor, contacte al investigador principal si aún desea participar',
  noFolBotNot: 'No deseo seguir',
  noFolBotYes: 'Deseo Aceptar y seguir',
}

export const es = {
  header: 'Questo: el chatbot que te acompaña',
  placeholder: 'Escribe el mensaje',
  hello1: 'Hola ',
  hello2:
    '! soy Questo, Camilo me creó para acompañarte en esta interesante encuesta sobre marcas!',
  start: 'Hola, Comencemos!',
  name: 'Para conocernos mejor, por favor dime tu nombre (NOMBRES y APELLIDOS)',
  worry: 'No te preocupes, todo lo que me cuentes queda entre nosotros! 😉',
  nameAns1: 'Hola ',
  nameAns2: ', gusto en conocerte!',
  gender: 'Y tú eres?',
  genA: ' 🧑 Hombre',
  genAa: 'masculino',
  genB: '👧 Mujer',
  genBb: 'femenino',
  genC: '🧑‍🦱 No-binario',
  genCc: ' de género no-binario',
  genHappy1: 'Genial! es bueno contar con ',
  genHappy2: ' el día de hoy, no es muy frecuente! 🤔',
  age: 'Y... en qué rango de edad te encuentras?',
  look: 'Genial! luces muy bien! 😍',
  brand: 'Ahora vamos a hablar de la marca que elegiste en la encuesta de hoy!',
  thinkBrand:
    'Quisiera que pensaras en los momentos que pasas con esta marca y me respondas lo que piensas de cada pregunta a continuación:',
  nextQ:
    'En las siguientes preguntas deberás contestar en una escala De 1 a 6 (uno es nada de acuerdo y 6 sotalmente de acuerdo), ¿estamos listos?',
  startBrandA: 'Si 👍',
  startBrandB: 'No 👎',
  backSoon: 'Qué pasó?😲 No te preocupes, vuelve cuando estés listo!',
  bye1: 'Gracias por tu tiempo ',
  bye2: ', espero que nos volvamos a ver!',
  done: 'Hecho',
  startMed: 'Continuemos nuestro camino 😉',
  recall:
    'Recuerda contestar en una escala De 1 a 6 (uno es nada de acuerdo y 6 sotalmente de acuerdo)',
  goMed: 'De acuerdo, sigamos 👍',
  save: 'Guardar',
  continue: 'Continuar',
}

/////////////////////////////////////
//////////// GLOBAL TEXT FRANCAIS ////////////
/////////////////////////////////////
export const welcomeFr = {
  titleIntro:
    'Étude sur la relation à la marque et les perceptions des chatbots de marque',
  title: 'Bonjour et bienvenue.',
  subTitleInf: "INFORMATIONS SUR L'ÉTUDE",
  inf1Par:
    "Bienvenue à mon étude consacrée à l'utilisation des Chatbots, je suis Camilo ROJAS-CONTRERAS, doctorant en sciences de gestion à l'Université Grenoble Alpes, France, sous la direction du professeur, Dr Pierre VALETTE-FLORENCE.",
  inf2Par:
    "Vous avez été invité à participer à une étude dont le but est d'explorer les effets possibles de la relation à la marque sur la perception des chatbots de marque. Avant de décider de participer, il est primordial que vous compreniez les raisons pour lesquelles cette recherche est menée ainsi que ses implications possibles. Veuillez prendre le temps de lire les informations ci-après. Si vous avez besoin d'informations supplémentaires, n'hésitez pas à contacter le chercheur principal du projet, Camilo Rojas. Vous trouverez ses coordonnées à la fin de cette page de présentation.",
  goalTitle: 'DANS QUEL BUT CETTE RECHERCHE EST-ELLE MENÉE ?',
  goalPar:
    "En vue de faire avancer les progrès dans le déploiement des assistants virtuels, cette étude vise à comprendre l'impact de la relation à la marque sur la perception et l'expérience de l'utilisation des chatbots.",
  botDefTitle: "C'EST QUOI UN CHATBOT ?",
  botDefPar:
    "Les assistants virtuels conversationnels ou chatbots sont des programmes conçus afin de simuler une conversation (ou chat) par l'utilisation du langage naturel dans l'interaction avec l'utilisateur au moyen d'applications, de sites web ou de dispositifs mobiles. Ils sont utilisés pour améliorer l'expérience client dans les processus d'achat, le service client, la gestion des paiements, entre autres.",
  criterTitle: 'EST-CE QUE JE RÉPONDS AUX CRITÈRES DE PARTICIPATION ?',
  criterPar:
    "Pour participer à cette étude, vous devez avoir au moins 18 ans. Cette recherche est ouverte aux étudiants et aux non-étudiants. De même, il n'y a pas de restriction de genre dans cette étude.",
  questAboutTitle:
    'SUR QUOI PORTERONT LES QUESTIONS ET QUE SE PASSERA-T-IL AVEC MES DONNÉES ?',
  questAbout1Par:
    "Pendant le remplissage de ce questionnaire, vous resterez anonyme, des données démographiques telles que l'âge, le sexe et la catégorie socioprofessionnelle vous seront demandées. L'enquête est composée de 5 questionnaires relatifs à la relation à la marque, l'anthropomorphisme, la distance sociale et l'acceptation du chatbot. Cette enquête prend entre 7 et 9 minutes à compléter.",
  questAbout2Par:
    "Vos données sont stockées sous forme électronique et protégées par mot de passe. Vous ne recevrez pas de copie des données collectées ici. Le chercheur principal, le superviseur, ainsi que les membres concernés de l'Université Grenoble Alpes y auront accès à des fins exclusivement académiques.",
  questAbout3Par:
    "Au terme de cette étude, vos réponses resteront anonymes, même pour les publications et les présentations. Cela comprend la possibilité de partager les informations avec d'autres chercheurs, tant que les informations restent anonymes et sous notre autorisation, sans possibilité d'être partagées par des tiers.",
  contactTitle: 'Contact chercheur principal : ',
  contactPar:
    "Camilo ROJAS-CONTRERAS, doctorant en Sciences de Gestion, Université Grenoble Alpes. Bureau Salle mainguy CETA C.E.R.A.G. 150 Rue de la Chimie 38040 Saint-Martin-d'Hères, France.",
  // E-mail: camilo.rojas@univ-grenoble-alpes.fr",
  ///////////////////////////////////////////////
  default1NotUser:
    "Bienvenue à mon étude consacrée à l'utilisation des Chatbots, je suis Camilo ROJAS-CONTRERAS, doctorant en sciences de gestion à l'Université Grenoble Alpes, France, sous la direction de Pierre VALETTE-FLORENCE.",
  default2NotUser:
    'Cette enquête vise à comprendre comment les consommateurs perçoivent les marques ainsi que les assistants virtuels intelligents. Le questionnaire couvre leurs intérêts pour les marques, leur perception des chatbots, ainsi que leurs attentes et opinions.',
  defaultUserExist: "Celle-ci sera d'une grande utilité pour cette recherche.",
  default3NotUser:
    "Si vous souhaitez participer ou réintégrer l'enquête, veuillez contacter la plate-forme d'enquête qui vous a fourni ce lien web. Encore merci !",
  endThanks: 'Merci !',
  selBrand: "Veuillez choisir une marque et préciser si vous l'avez utilisée.",
  mandFIelds: 'Veuillez remplir tous les champs',
  alertRgpd:
    'Pour continuer, veuillez accepter le traitement des données personnelles',
  lang:
    'Afin de participer à cette enquête, veuillez sélectionner la langue de votre préférence, puis cliquez sur "Continuer"',
  firstP:
    "Je suis Camilo ROJAS-CONTRERAS, doctorant en sciences de gestion à l'Université Grenoble Alpes, France, sous la direction de Pierre VALETTE-FLORENCE. Cette enquête porte sur la façon dont les consommateurs perçoivent les marques et les assistants virtuels intelligents. Le questionnaire couvre vos intérêts pour les marques, votre perception des chatbots, ainsi que vos attentes et opinions.",
  secondP:
    'Les données personnelles collectées via ce questionnaire sont traitées avec votre consentement.',
  thirdP:
    "Vos réponses sont facultatives et l'absence de réponse est sans conséquence. Vos données ne seront transmises qu'aux personnes autorisées, tenues à la confidentialité, et seront conservées pendant 24 mois après la fin de cette enquête. Vos données ne seront en aucun cas utilisées à des fins commerciales. ",
  // Pour tout renseignement complémentaire, n'hésitez pas à me contacter par e-mail : camilo.rojas@univ-grenoble-alpes.fr.",
  question:
    'En cliquant sur "Oui" ci-dessous, vous indiquez que vous avez au moins 18 ans, que vous avez lu ce formulaire de consentement et que vous acceptez de participer à cette étude de recherche et au traitement de vos données.',
  yes: 'Oui',
  no: 'Non',
  cont: 'Suivant',
  brandSel: 'Veuillez sélectionner votre marque préférée.',
  brandDistant:
    "Pour ce questionnaire, je vous invite à choisir la marque que vous connaissez le MOINS, et si possible, que vous n'avez jamais utilisée.",
  usedBrand: 'Est-ce que vous possédez ou avez déjà possédé cette marque ?',
  vidTxt1: 'Afin de vous familiariser avec le fonctionnement du chatbot de ',
  vidTxt2:
    ', veuillez regarder la vidéo suivante avant de répondre au questionnaire.',
  levelUp:
    'Excellent ! Nous avons franchi la première étape, on peut passer à la suivante ?',
  title1End: 'Merci beaucoup de votre contribution  ',
  title2End:
    ' ! Pour terminer l\'enquête, veuillez remplir les données ci-dessous, puis cliquez sur "terminer"',
  ageUser: 'Quel âge avez-vous ? ',
  ageLabel: 'Age',
  cspUser: 'Quelle est votre catégorie socioprofessionnelle ?',
  agric: 'Agriculteur',
  comerce: ' Commerçant ou artisan',
  chef: 'Cadre supérieur ou profession intellectuelle',
  employ: 'Employé',
  ouvrier: 'Ouvrier',
  retaite: ' Retraité',
  student: 'Étudiant',
  inactif: 'Sans occupation',
  genderUser: 'Et votre genre ?',
  genA: ' 🧑 Un homme',
  genAa: 'un homme',
  genB: '👧 Une Femme',
  genBb: 'une femme',
  genC: '🧑‍🦱 Non-binaire',
  genCc: "quelqu'un de genre non-binaire",
  finish: 'Terminer',
  noFolSurvey1:
    "Veuillez nous excuser, l'enquête n'est pas disponible pour le moment.",
  noFolSurvey2:
    'Si vous souhaitez toujours participer, veuillez contacter le chercheur principal.',
  noFolBotNot: 'Non, je ne souhaite pas participer',
  noFolBotYes: 'Je souhaite accepter et participer',
}

export const fr = {
  header: 'Questo : le chatbot qui vous accompagne',
  placeholder: 'Saisir le message',
  hello1: 'Salut ',
  hello2:
    " ! Je me présente, je suis Questo, Camilo m'a créé pour t'accompagner dans cette intéressante enquête à propos  des marques !",
  start: "Salut, c'est parti !",
  name:
    "Afin de mieux nous connaître, merci de me préciser comment tu t'appelles (PRÉNOM et NOM).",
  worry:
    "Ne t'inquiète pas, toutes les informations que tu vas me transmettre aujourd'hui resteront entre nous, promis ! 😉",
  nameAns1: 'Salut ',
  nameAns2: ', ravi de te rencontrer !',
  gender: 'Et toi, tu es ?',
  genA: ' 🧑 Un homme',
  genAa: 'un homme',
  genB: '👧 Une Femme',
  genBb: 'une femme',
  genC: '🧑‍🦱 Non-binaire',
  genCc: "quelqu'un de genre non-binaire",
  genHappy1: "Super ! C'est bien de trouver ",
  genHappy2: " aujourd'hui, ne viennent pas me voir très fréquemment ! 🤔",
  age: "Et... dans quelle tranche d'âge tu te places ?",
  look: "Super ! Tu as l'air en forme ! 😍",
  brand:
    "Parlons maintenant de la marque que tu as choisie dans le questionnaire d'aujourd'hui !",
  thinkBrand:
    "J'aimerais que tu réfléchisses aux moments que tu passes avec cette marque et que tu répondes à chacune des questions ci-dessous :",
  nextQ:
    'Dans les questions suivantes, tu devras répondre selon une échelle de 1 à 6 ( 1 signifie "pas du tout d\'accord" et 6 "tout à fait d\'accord"), on est prêt ?',
  startBrandA: 'Oui 👍',
  startBrandB: 'Non 👎',
  backSoon:
    "Que s'est-il passé ?😲 Ne t'inquiète pas, reviens quand tu seras prêt !",
  bye1: 'Merci pour ton temps ',
  bye2: ', au plaisir de te revoir !',
  done: 'Fait',
  startMed: 'Reprenons notre route 😉',
  recall:
    "Souviens-toi, repondre sur une échelle de 1 à 6 (un est pas du tout d'accord et 6 est tout à fait d'accord).",
  goMed: 'Allons-y 👍',
  save: 'Enregistrer',
  continue: 'Continuer',
}

/////////////////////////////////////
//////////// GLOBAL TEXT ENGLISH ////////////
/////////////////////////////////////
export const welcomeEn = {
  titleIntro:
    'Investigating about brand relationship and perceptions of branded chatbots',
  title: 'Hello and wellcome',
  subTitleInf: 'STUDY INFORMATION',
  inf1Par:
    "Welcome to my survey concerning chatbots, I'm Camilo ROJAS-CONTRERAS, PhD student in Management Sciences at the University of Grenoble Alpes, France, under the supervision of Professor, Dr Pierre VALETTE-FLORENCE.",
  inf2Par:
    'You have been invited to take part in a study that aims to explore the possible effects of the brand relationship on the perception of branded chatbots. Before you decide to participate, it is important for you to understand why this research is being conducted as well as the possible research implications. Please take the time to read the following information. In case you require additional information, feel free to contact the principal investigator of the project, Camilo Rojas. You will find the contact details at the end of this presentation page.',
  goalTitle: 'WHAT IS THE PURPOSE OF THIS RESEARCH?',
  goalPar:
    'With the aim of advancing improvements in the deployment of virtual assistants, this study attempts to understand how the relationship to the brand impacts the perception and experience of using chatbots.',
  botDefTitle: 'WHAT ARE CHATBOTS?',
  botDefPar:
    'Conversational virtual assistants or chatbots are programs designed to simulate a conversation (or chat) through the use of natural language in the interaction with the user by means of applications, websites or mobile devices. They are used to improve the customer experience in purchasing processes, customer service, payment management, and so on.',
  criterTitle: 'DO I MEET THE PARTICIPATION CRITERIA?',
  criterPar:
    'To participate in this study, you must be 18 years of age or older. This research is open to both students and non-students. Likewise, there are no gender restrictions in this study.',
  questAboutTitle:
    'ABOUT WHAT WILL I BE ASKED AND WHAT WILL HAPPEN TO MY DATA?',
  questAbout1Par:
    'During the completion of this questionnaire you will remain anonymous, demographics such as age, gender and socio-professional category will be asked. The survey is composed of 5 questionnaires related to brand relationship, anthropomorphism, social distance and chatbot acceptance. This survey takes between 7 and 9 minutes to complete.',
  questAbout2Par:
    'Your data is electronically stored and password protected. You will not receive a copy of the data collected here. The principal investigator, supervisor, as well as relevant members of the University Grenoble Alpes will have access for academic purposes only.',
  questAbout3Par:
    'After completing this study, your responses will remain anonymous even for publications and presentations. This includes the possibility of sharing information with other researchers, as long as the information remains anonymous and under our authorization, without the possibility of being shared by third parties.',
  contactTitle: 'Principal researcher contact:',
  contactPar:
    "Camilo ROJAS-CONTRERAS, PhD student in Management Sciences, University Grenoble Alpes. Office Room mainguy CETA C.E.R.A.G. 150 Rue de la Chimie 38040 Saint-Martin-d'Hères, France. ",
  // E-mail: camilo.rojas@univ-grenoble-alpes.fr",
  ///////////////////////////////////////////////
  default1NotUser:
    'Welcome to my study focused on the use of Chatbots, my name is Camilo ROJAS-CONTRERAS, PhD student in Management Sciences at the University of Grenoble Alpes, France, under the supervision of Pierre VALETTE-FLORENCE.',
  default2NotUser:
    'This survey aims to explore how consumers perceive brands as well as intelligent virtual assistants. The survey covers their interests in brands, their perceptions of chatbots, and their expectations and opinions.',
  defaultUserExist: 'It will be very useful for this research.',
  default3NotUser:
    'If you would like to contribute or retake the survey, please contact the survey platform that provided you with this web link.',
  endThanks: 'Thank you again!',
  selBrand:
    'To continue please choose a brand and specify if you have used it.',
  mandFIelds: 'Please complete all fields',
  alertRgpd: 'To continue please accept Personal Data treatment',
  lang:
    'In order to complete this survey, please select your desired language and then press continue.',
  firstP:
    "I'm Camilo ROJAS-CONTRERAS, PhD student in Management Sciences at Université Grenoble Alpes, France, under the supervision of Pierre VALETTE-FLORENCE. This survey focuses on how consumers perceive brands and Intelligent Virtual Assistants.",
  secondP:
    'The questionnaire covers your interests in brands, your perception of chatbots, as well as your expectations and opinions.',
  thirdP:
    'Your answers are optional and failure to answer is without consequence. Your data will be transmitted only to authorized persons, who are obliged to maintain confidentiality, and will be kept for 24 months after the end of this survey. Your data will not be used for commercial purposes under any circumstances.',
  // For further information, please feel free to contact me by e-mail: camilo.rojas@univ-grenoble-alpes.fr',
  question:
    'By clicking "Yes" below, you are indicating that you are at least 18 years old, that you have read this consent form, and that you agree to participate in this research study and the treatment of your data.',
  yes: 'Yes',
  no: 'No',
  cont: 'Continue',
  brandSel: 'Please select your preferred brand from the list below.',
  brandDistant:
    'For this exercise, I invite you to choose the brand you know the LEAST and, if possible, the one you have never used.',
  usedBrand: 'Are you using or have you ever used this brand?',
  vidTxt1: 'To give you a close experience on how the',
  vidTxt2:
    'chatbot works, please watch the following video before proceeding with the survey.',
  levelUp: 'All right! we have finished the first part, shall we go on?',
  title1End: 'Thank you so much for your contribution ',
  title2End:
    '! To complete the survey, please fill in the data below, then click on "finish"',
  ageUser: 'How old are you? ',
  ageLabel: 'Age',
  cspUser: 'What is you professional background?',
  agric: 'Farmer',
  comerce: 'Artisan, shopkeeper or CEO',
  chef: 'Executive or intellectual professional',
  employ: 'Employee',
  ouvrier: 'Worker',
  retaite: 'Retired',
  student: 'Student',
  inactif: 'Unemployed',
  genderUser: 'What about your gender?',
  genA: ' 🧑 A men',
  genAa: 'a men',
  genB: '👧 A woman',
  genBb: 'a woman',
  genC: '🧑‍🦱 Non-binary',
  genCc: 'a non-binary person',
  finish: 'Finish',
  noFolSurvey1: 'We apologize, the survey is not available at this time.',
  noFolSurvey2:
    'Please contact the main researcher if you would like to participate.',
  noFolBotNot: 'No, I do not wish to participate',
  noFolBotYes: 'I want to accept and participate',
}
export const eng = {
  header: 'Questo: The chatbot to assist you',
  placeholder: 'Write message',
  hello1: 'Hi ',
  hello2:
    " ! I'm Questo, Camilo created me to assist you in this interesting survey about brands!",
  start: "Hey, let's go!",
  name:
    'To get to know us better, please provide me with your name ( FIRST NAME and LAST NAME).',
  worry:
    "Don't worry, all the information that you' will share with me today will remain between us, I promise 😉",
  nameAns1: 'Hello ',
  nameAns2: ', nice to meet you!',
  gender: 'And you are?',
  genA: ' 🧑 A men',
  genAa: 'a men',
  genB: '👧 A woman',
  genBb: 'a woman',
  genC: '🧑‍🦱 Non-binary',
  genCc: 'a non-binary person',
  genHappy1: "Great! It's nice to meet ",
  genHappy2: " today, they don't come to see me very often! 🤔",
  age: 'And... what age range do you fit into?',
  look: 'Amazing! You look great! 😍',
  brand:
    "Now let's talk about the brand you have chosen in today's questionnaire !",
  thinkBrand:
    "I'd like you to think about the moments you experience with this brand and respond to each of the questions below:",
  nextQ:
    'For the following questions, please answer on a scale of 1 to 6 (1 means "strongly disagree" and 6 means "strongly agree"), are we ready?',
  startBrandA: 'Yes 👍',
  startBrandB: 'No 👎',
  backSoon: "What happened? 😲 Don't worry, come back when you're ready!",
  bye1: 'Thanks for your time ',
  bye2: ', I look forward to seeing you again!',
  done: 'Done',
  startMed: "Let's keep on our journey 😉",
  recall:
    'Please keep in mind answering on a scale of 1 to 6 (one is not at all agree and 6 is strongly agree)',
  goMed: "Let's go 👍",
  save: 'Save',
  continue: 'Continue',
}

/////////////////////////////////////
//////////// GLOBAL TEXT PORTUGUESE ////////////
/////////////////////////////////////
export const welcomePtg = {
  titleIntro:
    'Pesquisa sobre relação da marca e percepções dos chatbots da marca',
  title: 'Olá e seja bem-vindo',
  subTitleInf: 'INFORMAÇÕES SOBRE O ESTUDO',
  inf1Par:
    'Bem-vindo à minha enquete sobre chatbots, sou Camilo Rojas-Contreras, estudante de doutorado em Ciências da Gestão na Universidade de Grenoble Alpes, França, orientado pelo Prof., Dr. Pierre Valette-Florence..',
  inf2Par:
    'Você foi convidado para participar de um estudo que visa explorar os possíveis efeitos da relação da marca sobre a percepção dos "chatbots" da marca. Antes de decidir participar, é importante que você entenda porquê esta pesquisa está sendo aplicada, assim como as possíveis implicações da mesma. Por gentileza, reserve um tempo para ler as seguintes informações. No caso precisar de maior informação, sinta-se à vontade de contatar o pesquisador principal do projeto, Camilo Rojas. Você encontrará os detalhes de contato no final desta tela de apresentação',
  goalTitle: 'QUAL É O OBJETIVO DESTA PESQUISA?',
  goalPar:
    'Tendo em vista o avanço na implantação de assistentes virtuais, este estudo tenta perceber como a relação com a marca impacta a percepção e a experiência do uso dos chatbots.',
  botDefTitle: 'MAS, O QUE SÃO CHATBOTS?',
  botDefPar:
    'Assistentes virtuais de conversação ou chatbots são programas projetados para simular uma conversação (ou bate papo) através do uso de linguagem natural na interação com o usuário por meio de aplicativos, websites ou dispositivos móveis. São usados para melhorar a experiência do cliente nos processos de compra, atendimento ao cliente, gerenciamento de pagamentos, além de outros.',
  criterTitle: 'EU CUMPRO OS CRITÉRIOS DE PARTICIPAÇÃO?',
  criterPar:
    'Para participar neste estudo, você deve ter a mais de 18 anos. Esta pesquisa é aberta tanto para estudantes quanto para não estudantes. Igualmente, a pesquisa não tem restrições de gênero.',
  questAboutTitle:
    'SOBRE O QUE SEREI PERGUNTADO E O QUE ACONTECERÁ COM MEUS DADOS?',
  questAbout1Par:
    'No preenchimento deste questionário você permanecerá anônimo, serão perguntados dados demográficos tais como idade, sexo e categoria sócio-profissional. A pesquisa é composta de 5 questionários relacionados ao relacionamento com a marca, antropomorfismo, distância social e aceitação de chatbot. O percurso da enquete leva de 7 até 9 minutos.',
  questAbout2Par:
    'Seus dados serão armazenados eletronicamente e protegidos por senha. Além disso, você não receberá uma cópia dos dados coletados aqui. O pesquisador principal, orientador, assim como integrantes da equipa de pesquisa da Universidade Grenoble Alpes somente terão acesso para fins acadêmicos.',
  questAbout3Par:
    'Uma vez concluído este estudo, as suas respostas permanecerão anônimas mesmo para publicações e apresentações. O que inclui a possibilidade de compartilhar informações com outros pesquisadores, desde que as informações permaneçam anônimas e sobre nossa autorização, sem a possibilidade de serem compartilhadas com terceiros.',
  contactTitle: 'Principal researcher contact:',
  contactPar:
    "Pesquisador principal: Camilo ROJAS-CONTRERAS, doutorando em Ciências de Gestão, Universidade Grenoble Alpes. Escritório principal CETA C.E.R.A.G. 150 Rue de la Chimie 38040 Saint-Martin-d'Hères, França.",
  // E-mail: camilo.rojas@univ-grenoble-alpes.fr",
  default1NotUser:
    'Bem-vindo ao estudo focado no uso de Chatbots, meu nome é Camilo ROJAS-CONTRERAS, estudante de doutorado em Ciências Gerenciais na Universidade de Grenoble Alpes, França, sob a supervisão de Pierre VALETTE-FLORENCE.',
  default2NotUser:
    'Esta pesquisa tem como objetivo explorar como os consumidores percebem as marcas, assim como os assistentes virtuais inteligentes. Este estudo aborda seus interesses em marcas, as percepções que têm de chatbots, e suas expectativas e opiniões.',
  defaultUserExist:
    'A sua participação será muito útil para esta pesquisa. Em breve será redirecionado para obter  seus pontos.',
  default3NotUser:
    'No caso quer contribuir ou retomar a pesquisa, favor entrar em contato com a plataforma de pesquisa que lhe forneceu este link.',
  endThanks: 'Mais uma vez, valeu!',
  selBrand:
    'Para continuar, favor escolher uma marca e especificar se você já a usou.',
  mandFIelds: 'Por favor, complete todos os campos',
  alertRgpd: 'Para continuar, por favor, aceite o tratamento de Dados Pessoais',
  lang:
    'A fim de completar esta pesquisa, favor escolher o idioma desejado e, em seguida, pressione continuar.',
  firstP:
    'Sou Camilo ROJAS-CONTRERAS, estudante de doutorado em Ciências de Gestão na Université Grenoble Alpes, França, sob a supervisão de Pierre VALETTE-FLORENCE. Esta pesquisa enfoca como os consumidores percebem as marcas e os Assistentes Virtuais Inteligentes.',
  secondP:
    'Este questionário trata de seus interesses em marcas, sua percepção de chatbots, assim como suas expectativas e opiniões.',
  thirdP:
    'Seus dados não serão em hipótese alguma utilizados para fins comerciais.',
  // Para maiores informações, sinta-se à vontade para entrar em contato comigo pelo e-mail: camilo.rojas@univ-grenoble-alpes.fr',
  question:
    'Clicando em "Sim" embaixo, você está indicando que tem pelo menos 18 anos, que leu este formulário de aceitação, e concorda em participar desta pesquisa e do tratamento de seus dados.',
  yes: 'Sim',
  no: 'Não',
  cont: 'PROSSEGUIR',
  brandSel:
    'Por favor, faça a seleção de sua marca preferida da listagem a seguir.',
  brandDistant:
    'Para este exercício, o convido a escolher a marca que você conhece o MENOS e, se possível, aquela que você nunca usou.',
  usedBrand: 'Você está usando ou já usou esta marca?',
  vidTxt1: 'Para lhe dar uma experiência mais próxima sobre',
  vidTxt2:
    'como funciona o chatbot, assista ao vídeo abaixo antes de prosseguir.',
  levelUp: 'Bem! já terminamos a primeira parte, podemos continuar?',
  title1End: 'Muito obrigado pela sua contribuição',
  title2End:
    '! Para preencher a pesquisa, por favor, complete os dados abaixo, depois clique em "Terminar"',
  ageUser: 'Que idade você tem? ',
  ageLabel: 'Idade',
  cspUser: 'Qual é sua ocupação sócio profissional?',
  agric: 'Agricultor',
  comerce: 'Artesão, lojista ou Diretor Executivo',
  chef: 'Executivo ou profissional intelectual',
  employ: 'Empregado',
  ouvrier: 'Operário',
  retaite: 'Aposentado',
  student: 'Estudante',
  inactif: 'Desempregado',
  genderUser: 'E quanto ao seu gênero?',
  genA: ' 🧑 Un homem',
  genAa: 'un homem',
  genB: '👧 Uma mulher',
  genBb: 'uma mulher',
  genC: '🧑‍🦱 Não-binário',
  genCc: 'uma pessoa não binária',
  finish: 'Terminar',
  noFolSurvey1: 'Lamentamos, o inquérito não está disponível de momento.',
  noFolSurvey2:
    'Por favor, contate o pesquisador principal se você deseja contribuir.',
  noFolBotNot: 'Não, eu não desejo participar',
  noFolBotYes: 'Eu quero aceitar e participar',
}
export const ptg = {
  header: 'Questo: O chatbot para orientá-lo',
  placeholder: 'Escrever mensagem',
  hello1: 'Olá ',
  hello2:
    '! Sou Questo, Camilo criou-me para acompanhá-lo nesta interessante enquete sobre marcas!',
  start: 'Então, bora lá!',
  name:
    'Para nos conhecer melhor, por favor, me forneça seu nome (PRIMEIRO NOME e SOBRENOME).',
  worry:
    'Não se preocupe, todas as informações que você vai compartilhar comigo hoje permanecerão entre nós, eu prometo 😉',
  nameAns1: 'Olá ',
  nameAns2: ', prazer em conhecê-lo!',
  gender: 'E você é...',
  genA: ' 🧑, um homem',
  genAa: 'um homem',
  genB: '👧 Uma mulher',
  genBb: 'uma mulher',
  genC: '🧑‍🦱 Não binário',
  genCc: 'uma pessoa não binária',
  genHappy1: 'Ótimo! É um prazer encontrar ',
  genHappy2: ' hoje, eles não vêm me ver com muita freqüência! 🤔',
  age: 'E... em que intervalo de idade você se encaixa?',
  look: 'Incrível! Você está ótimo! 😍',
  brand:
    'Agora vamos falar sobre a marca que você escolheu no questionário de hoje',
  thinkBrand:
    'Gostaria que você pensasse nos momentos que vivenciou com esta marca e respondesse a cada uma das perguntas a seguir:',
  nextQ:
    '•	Para as seguintes perguntas, por favor responda numa escala de 1 a 6 (1 significa " discordo fortemente" e 6 significa "concordo fortemente"), estamos prontos?',
  startBrandA: 'Sim 👍',
  startBrandB: 'Não 👎',
  backSoon:
    'Que aconteceu? 😲 Não se preocupe, volte quando você estiver pronto!',
  bye1: 'Obrigado por seu tempo ',
  bye2: 'espero vê-lo novamente!',
  done: 'Feito',
  startMed: 'Continuamos gente 😉',
  recall:
    'Por favor, tenha em mente responder em uma escala de 1 a 6 (um não concorda de jeito nenhum e 6 concorda fortemente)',
  goMed: 'Continuemos 👍',
  save: 'Salvar',
  continue: 'Continuar',
}
